import { IconButton, Menu, MenuItem, Avatar } from "@mui/material";
import { useState } from "react";
import { handleLogout } from "../../services/logoutHandler";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export default function UserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useAuth();
const handleClickLogout = () => {
    setAnchorEl(null);
    handleLogout(dispatch, user, navigate, "manual", null);
  };
  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
         <Avatar alt="Remy Sharp" src="https://sm.askmen.com/askmen_in/article/f/facebook-p/facebook-profile-picture-affects-chances-of-gettin_fr3n.jpg" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {/* <MenuItem>Profile</MenuItem>
        <MenuItem>Settings</MenuItem> */}
        <MenuItem onClick={handleClickLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
}
